import { memo, useEffect } from 'react';
import { Theme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { UserForm } from '../../../components/form/user-form/user-form';
import { useUser } from '../../../components/form/user-form/use-user';
import { validateUser } from '../../../models/validate-user';
import { emptyUser } from '../../../models/empty-user';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
  });
};

export interface IAddMemberModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: any;
  handleAddMember: (data: any) => void;
  selectMember: any;
}

const AddMemberModal = ({
  open,
  handleClose,
  handleAddMember,
  selectMember,
}: IAddMemberModalProps) => {
  const { updateUser, user, resetState } = useUser({ ...emptyUser });
  const { fieldErrors, hasErrors } = validateUser(user, ['parentId', 'role', 'status']);
  const intl = useIntl();

  useEffect(() => {
    handleClose();
    resetState();
  }, [selectMember.loading]);

  const onClickActionButton = () => {
    if (!hasErrors) {
      const memberData = {
        name: user.profile.name,
        email: user.email,
        contactNumber: user.profile.contactNumber,
        password: user.password,
      };
      handleAddMember(memberData);
    }
  };

  const onClose = () => {
    handleClose();
    resetState();
  };

  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'add_member',
      })}
      modalDescription={intl.formatMessage({
        id: 'make_member_manage_meetings',
      })}
      id="add-member-modal"
      open={open}
      isSingleButton
      handleClose={onClose}
      actinButtonOnClick={onClickActionButton}
      actinButtonLabel={intl.formatMessage({
        id: 'add_member',
      })}
      actionButtonDisabled={hasErrors}
    >
      <UserForm
        user={user}
        updateUser={updateUser}
        fields={{
          name: {
            error: fieldErrors.name,
            required: true,
          },
          contactNumber: {
            error: fieldErrors.contactNumber,
            required: true,
          },
          email: {
            error: fieldErrors.email,
            required: true,
          },
          status: {
            error: fieldErrors.status,
            required: true,
          },
          password: {
            error: fieldErrors.password,
            required: true,
          },
        }}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(AddMemberModal));
